module.exports = __webpack_public_path__ + "static/media/aeropay_connect_bank_blkblu.6cf84922.png";